/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import "@/assets/stylus/stubParamsConfig.styl";
import moment from "moment";
// import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Row, Col, message, Card, Table, Modal, Input, Upload } from "antd";
import { TableLocale } from "@/utils/publicParam";
import fetchHandler from "@/fetch/fetchHandler";
import {
  prefixFile,
  stubCfgInfo,
  stubCfgSync,
  cfgFromStub,
  stubCfgSave,
  stubCmd,
  checkJQfile,
} from "@/fetch/fetchApi";
// import ConfigModify from './configModify';
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Tool from "@/utils/Tool";
import "./index.styl";
import ModifyLog from "./modifyLog";
import StubParamPriceModal from "./stubParamPriceModal";
import StubParamChargingModal from "./stubParamChargingModal";

let isEdit = false;
let saveVisible = "none";

const timeTypeMap = new Map([
  [1, "峰"],
  [2, "尖"],
  [3, "谷"],
  [4, "平"],
]);
@connect((state) => state)
class StubParamsConfig extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubParamsConfig;
    this.state = {
      cfgData: {},
      data: [],
      stubId: this.props.stubId,
      stubGroupName: this.props.stubGroupName,
      devType: this.props.devType,
      configModifyVisible: false,
      resultData: new Map(),
      editList: [],
      tableColumnsModel: null,
      changeData: {},
      changeValueFlag: false, // 修改配置模式
      getNewConfigFlag: false,
      secondGetNewConfig: 0,
      checkBtnLoading: false,
      priceSetVisible: false,
      chargingSetVisible: false,
      fileName: "",
      fileLists: [],
    };
    this.init();
  }

  componentWillMount() {
    this.setState({
      tableColumnsModel: this.tableConfig(),
    });
  }

  tableConfig = () => {
    const uploadProps = {
      // 显支持上传png、jpg、pdf、word、Excel格式的文件，支持多选上传，文件大小不能超过100M
      accept: ".txt",
      action: `${prefixFile}/uploadFile.do`,
      data: () => {
        const fileName = `${moment(new Date()).format("x")}${Math.floor(
          Math.random() * 10,
        )}${Math.floor(Math.random() * 10)}${Math.floor(Math.random() * 10)}.txt`;
        this.setState({
          currentJQName: fileName,
        });
        return {
          storeName: "ds_upload",
          filePath: fileName,
        };
      },
      onChange: (e) => {
        console.log(e);
        if (e.fileList.length === 2) {
          e.fileList = e.fileList.slice(-1);
        }
        if (e.file.status === "done") {
          const record = this.state.cfgData.configData.filter((item) => item.key === "fileCrc")[0];
          this.handleStubCfgEditChange2(this.state.currentJQName.split(".")[0], record);
          this.setState({
            fileName: e.file.name,
          });
        }
        this.setState({
          fileLists: [...e.fileList],
        });
      },
      onRemove: () => {
        const record = this.state.cfgData.configData.filter((item) => item.key === "fileCrc")[0];
        this.setState({
          fileName: "",
          currentJQName: "",
        });
        console.log(this.state.resultData);
        this.handleStubCfgEditChange2("", record);
        this.delChangeResult();
        // const resultData = this.state.resultData.filter(item => item.name !== "本地鉴权的编码文件");
      },
    };
    const tableColumnsModel = [
      {
        title: this.internationalization.title1, // '配置字段(字段范围)',
        dataIndex: "name",
        key: "name",
        width: 230,
      },
      {
        title: "字段格式范围", // '字段格式范围',
        dataIndex: "des",
        key: "des",
        width: 300,
        className: "freedom-td",
        render: (text, record) => {
          if (record.key === "offlineBillingModel" || record.key === "reserveCharingStation") {
            const names = record.des.split(",");
            const first = names.shift();
            return (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #f0f0f0",
                    textAlign: "center",
                  }}>
                  {first}
                </div>
                <div className="config-sp-box">
                  {names.map((v) => (
                    <div>{v}</div>
                  ))}
                </div>
              </div>
            );
          }
          return <div style={{ padding: "10px", whiteSpace: "break-spaces" }}>{text}</div>;
        },
      },
      {
        title: this.internationalization.title6, // '设备端配置',
        dataIndex: "stubValue",
        render: (text, record) => {
          if (record.key === "offlineBillingModel" || record.key === "reserveCharingStation") {
            return null;
            // if (!record.stubValue) {
            //     return null;
            // }
            // const stubValue = JSON.parse(record.stubValue);
            // console.log(stubValue)
            // let strs = [];
            // if (record.key === 'offlineBillingModel') {
            //     for (let i = 0; i < stubValue.num; i++) {
            //         let startTime = stubValue['time' + (i - 1)] || '0000';
            //         let endTime = stubValue['time' + i];
            //         // 如果长度为3 例如700代指7点，需要前面补个0；
            //         if (startTime.length === 3) {
            //             startTime = 0 + startTime;
            //         }
            //         if (endTime.length === 3) {
            //             endTime = 0 + endTime
            //         }
            //         let timeStr = `${Tool.translateTime(startTime, 'HH:mm')}~${
            // Tool.translateTime(endTime, 'HH:mm')}`
            //         strs.push(`${timeStr} | ${stubValue['elePrice' + i]} |
            //  ${stubValue['serverPrice' + i]} | ${timeTypeMap.get(stubValue['type' + i])}`)
            //     }
            // }

            // if (record.key === 'reserveCharingStation') {
            //     for (let i = 0; i < stubValue.appointNum; i++) {
            //         let startTime = stubValue['appointStartTime'+i];
            //         let endTime = stubValue['appointEndTime'+i];

            //         let timeStr = `${Tool.translateTime(startTime, 'HH:mm')
            // }~${Tool.translateTime(endTime, 'HH:mm')}`
            //         strs.push(`${timeStr} | ${stubValue['appointEle' + i]} |
            // ${stubValue['appointTimeLen' + i]}`)
            //     }
            // }

            // return (
            //     <div style={{ display: 'flex', flexDirection: 'column' }}>
            //         <div style={{ padding: '10px', borderBottom: '1px solid #f0f0f0',
            //  textAlign: 'center' }}>{record.key === 'offlineBillingModel' ?
            // stubValue.num : stubValue.appointNum}</div>
            //         <div className="config-sp-box">
            //             {
            //                 strs.map((v) => <div>{v}</div>)
            //             }
            //         </div>
            //     </div>
            // );
          }
          // 计费规则
          if (
            record.key === "num" ||
            record.key === "time" ||
            record.key === "elePrice" ||
            record.key === "serverPrice" ||
            record.key === "type"
          ) {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                onClick={(e) => {
                  e.target.blur();
                  this.setState({
                    priceSetVisible: true,
                  });
                }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
              />
            );
          }
          // 预约充电配置
          if (
            record.key === "appointNum" ||
            record.key === "appointStartTime" ||
            record.key === "appointEndTime" ||
            record.key === "appointEle" ||
            record.key === "appointTimeLen"
          ) {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                onClick={(e) => {
                  e.target.blur();
                  this.setState({
                    chargingSetVisible: true,
                  });
                }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
              />
            );
          }
          if (record.key === "fileCrc") {
            if (this.state.changeValueFlag) {
              return (
                <div>
                  {text ? (
                    <a
                      href="javascript:void(0);"
                      style={{ display: "block", paddingLeft: 15 }}
                      onClick={() => this.handleDownload(text)}>
                      {text}.txt {this.internationalization.btn3}
                    </a>
                  ) : (
                    ""
                  )}
                  <Button
                    onClick={this.handleDownloadModal}
                    type="text"
                    style={{ color: "#5584FF" }}>
                    模板下载
                  </Button>
                  <Upload fileList={this.state.fileLists} maxCount={1} {...uploadProps}>
                    <Button type="text" style={{ color: "#5584FF" }}>
                      TXT上传
                    </Button>
                  </Upload>
                </div>
              );
            } else {
              return text ? (
                <a href="javascript:void(0);" onClick={() => this.handleDownload(text)}>
                  {text}
                  {this.internationalization.btn3}
                </a>
              ) : (
                ""
              );
            }
          } else {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
                onChange={(e) => this.handleStubCfgEditChange(e, record)}
              />
            );
          }
        },
      },
    ];
    return tableColumnsModel;
  };

  init() {
    // 调用接口获取数据
    this.fetch();
  }

  fetch() {
    // 表格加载效果
    this.setState({
      tableLoading: true,
    });
    fetchHandler(stubCfgInfo, {
      stubId: this.state.stubId,
      devType: this.state.devType,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState(
          {
            cfgData: res.data,
          },
          () => {
            this.setState({
              tableColumnsModel: this.tableConfig(),
            });
          },
        );
      }
    });
  }

  handleDownload = (value) => {
    // let  url = "https://app-ccchong-com.oss-cn-qingdao.aliyuncs.com/" + value + ".txt";

    const excelUrl = `${prefixFile}/exportStubCfgFile.do`;
    const params = `fileName=${value}`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
    // window.open(url);
    // window.URL.revokeObjectURL(url);
  };

  // 下载模板
  handleDownloadModal = (value) => {
    // let  url = "https://app-ccchong-com.oss-cn-qingdao.aliyuncs.com/" + value + ".txt";

    const excelUrl = `${prefixFile}/template/download.do`;
    const params = `fileName=鉴权编码文件模板.txt&serviceName=fileCrc`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
    // window.open(url);
    // window.URL.revokeObjectURL(url);
  };

  //

  // 记录每次修改的记录
  handleStubCfgEditChange = (e, record) => {
    const changeData = this.state.changeData;
    changeData[record.key] = e.target.value;
    this.setState({
      changeData: changeData,
    });

    // 类型有没有放入集合
    let isResult = true;
    // 判断数据集合中是否有数据，如果有数据进行逻辑处理
    if (this.state.resultData.size > 0) {
      const resuleMap = new Map();
      this.state.resultData.forEach((item, type) => {
        const arr = [];
        isResult = true;
        if (record.type === type) {
          isResult = false;
          let isExist = true;
          item.forEach((item1) => {
            item1.forEach((value, index2) => {
              const item1ValueMapObj = new Map();
              if (index2 === record.key) {
                isExist = false;
                if (e.target.value !== record.platformValue) {
                  item1ValueMapObj.set(index2, e.target.value);
                  arr.push(item1ValueMapObj);
                }
              } else {
                item1ValueMapObj.set(index2, value);
                arr.push(item1ValueMapObj);
              }
            });
          });
          if (isExist) {
            if (e.target.value !== record.platformValue) {
              const itemValueMapObj = new Map();
              itemValueMapObj.set(record.key, e.target.value);
              arr.push(itemValueMapObj);
            }
          }
          resuleMap.set(type, arr);
        } else {
          // let mapObj = new Map();
          resuleMap.set(type, item);
        }
      });

      if (resuleMap.size > 0) {
        this.state.resultData = resuleMap;
      }
    }
    if (isResult) {
      if (e.target.value !== record.platformValue) {
        const arr1 = [];
        const mapObj = new Map();
        mapObj.set(record.key, e.target.value);
        arr1.push(mapObj);
        // arr2.push(arr1);
        this.state.resultData.set(record.type, arr1);
      }
    }

    this.setState({
      resultData: this.state.resultData,
    });
  };

  // 记录特殊字段修改的记录
  handleStubCfgEditChange2 = (changedValue, record) => {
    const changeData = this.state.changeData;
    changeData[record.key] = changedValue;
    this.setState({
      changeData: changeData,
    });

    // 类型有没有放入集合
    let isResult = true;
    // 判断数据集合中是否有数据，如果有数据进行逻辑处理
    if (this.state.resultData.size > 0) {
      const resuleMap = new Map();
      this.state.resultData.forEach((item, type) => {
        const arr = [];
        isResult = true;
        if (record.type === type) {
          isResult = false;
          let isExist = true;
          item.forEach((item1) => {
            item1.forEach((value, index2) => {
              const item1ValueMapObj = new Map();
              if (index2 === record.key) {
                isExist = false;
                if (changedValue !== record.platformValue) {
                  item1ValueMapObj.set(index2, changedValue);
                  arr.push(item1ValueMapObj);
                }
              } else {
                item1ValueMapObj.set(index2, value);
                arr.push(item1ValueMapObj);
              }
            });
          });
          if (isExist) {
            if (changedValue !== record.platformValue) {
              const itemValueMapObj = new Map();
              itemValueMapObj.set(record.key, changedValue);
              arr.push(itemValueMapObj);
            }
          }
          resuleMap.set(type, arr);
        } else {
          // let mapObj = new Map();
          resuleMap.set(type, item);
        }
      });

      if (resuleMap.size > 0) {
        this.state.resultData = resuleMap;
      }
    }
    if (isResult) {
      if (changedValue !== record.platformValue) {
        const arr1 = [];
        const mapObj = new Map();
        mapObj.set(record.key, changedValue);
        arr1.push(mapObj);
        // arr2.push(arr1);
        this.state.resultData.set(record.type, arr1);
      }
    }

    this.setState({
      resultData: this.state.resultData,
    });
  };

  handleModifyBtnClick = () => {
    isEdit = true;
    saveVisible = "block";
    this.addTable();
    this.setState({
      configModifyVisible: true,
    });
  };

  componentDidMount() {
    message.warn(this.internationalization.msg1, 5);
  }

  handleSyncBtnClick = () => {
    stubCfgSync({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg2);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 使用设备端配置
  handleCfgFromStubBtnClick = () => {
    cfgFromStub({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg2);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  };

  handleModifyLogBtnClick = () => {
    this.setState({
      configModifyLogVisible: true,
      isNeedFlush: true,
    });
  };

  formatterResultData = () => {
    const { resultData, cfgData } = this.state;
    const results = [];

    resultData.forEach((values) => {
      values.forEach((val, index) => {
        const keys = Array.from(val.keys());
        const valArray = Array.from(val.values());
        const item = cfgData.configData.find((v) => v.key === keys[0]);
        results.push({
          value: valArray[0],
          name: item.name,
        });
      });
    });

    return results;
  };

  // 删除本地鉴权文件修改
  delChangeResult = () => {
    const { resultData } = this.state;
    // delete resultData["200"];
    resultData.delete("200");
    this.setState({
      resultData,
    });
  };

  handleSaveBtnClick = () => {
    if (this.state.resultData.size > 0) {
      const results = this.formatterResultData();
      console.log(results);
      Modal.confirm({
        icon: null,
        width: 800,
        content: (
          <div>
            <h4 style={{ textAlign: "center", marginBottom: "24px" }}>
              确认修改以下<span style={{ color: "red" }}>{results.length}</span>
              项参数吗？
            </h4>
            {results.map((v) => (
              <Row>
                <Col span={10} style={{ color: "red", textAlign: "right" }}>
                  {v.name}
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  修改为
                </Col>
                <Col span={10} style={{ color: "red" }}>
                  {v.name === "本地鉴权的编码文件" ? this.state.fileName : v.value}
                </Col>
              </Row>
            ))}
          </div>
        ),
        onOk: () => {
          // 首先校验鉴权文件
          if (results.filter((item) => item.name === "本地鉴权的编码文件").length > 0) {
            const fileInfo = results.filter((item) => item.name === "本地鉴权的编码文件");
            checkJQfile({
              storeName: "ds_upload",
              filePath: `${fileInfo[0].value}.txt`,
            }).then((res) => {
              if (res && res.data.code === "200") {
                stubCfgSave({
                  platformParams: JSON.stringify(this.strMapToObj(this.state.resultData)),
                  stubId: this.state.stubId,
                }).then((res2) => {
                  if (res2 && res2.data.code === "200") {
                    this.setState(
                      {
                        resultData: new Map(),
                        changeData: {},
                        configModifyVisible: false,
                        changeValueFlag: false,
                      },
                      () => {
                        this.init();
                        message.success("修改配置命令已下发，可一分钟后刷新查看最新配置");
                      },
                    );
                  } else {
                    message.error(res2.data.text);
                  }
                });
              } else {
                message.error(res.data.text);
              }
            });
          } else {
            stubCfgSave({
              platformParams: JSON.stringify(this.strMapToObj(this.state.resultData)),
              stubId: this.state.stubId,
            }).then((res) => {
              if (res && res.data.code === "200") {
                this.setState(
                  {
                    resultData: new Map(),
                    changeData: {},
                    configModifyVisible: false,
                    changeValueFlag: false,
                  },
                  () => {
                    this.init();
                    message.success("修改配置命令已下发，可一分钟后刷新查看最新配置");
                  },
                );
              } else {
                message.error(res.data.text);
              }
            });
          }
        },
      });
      // alert(JSON.stringify(this.strMapToObj(this.state.resultData)));
      // arr.push([this.state.resultData]);
    } else {
      message.info(this.internationalization.msg3);
    }
  };

  // 命令下发
  handleConfigCheckClick = () => {
    this.setState({
      checkBtnLoading: true,
    });
    stubCmd({ stubId: this.state.stubId }).then((res) => {
      this.setState({
        checkBtnLoading: false,
      });
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg4);
        this.init();
        this.getNewConfigFlag();
      } else {
        message.error(res.data.text);
      }
    });
  };

  strMapToObj(strMap) {
    const obj = Object.create(null);
    for (const [k, v] of strMap) {
      const arr = [];
      for (const val of v) {
        const obj2 = Object.create(null);
        for (const [i, j] of val) {
          obj2[i] = j;
          arr.push(obj2);
        }
      }
      obj[k] = arr;
    }
    return obj;
  }

  // 刷新
  handlerefreshBtnClick = () => {
    this.init();
    this.setState({
      tableLoading: false,
    });
  };

  // 获取最新配置60秒限制
  getNewConfigFlag = () => {
    this.setState({
      getNewConfigFlag: true,
      secondGetNewConfig: 60,
    });
    const timeOut = setInterval(() => {
      // console.log(this.state.secondGetNewConfig)
      if (this.state.secondGetNewConfig > 0) {
        const s = this.state.secondGetNewConfig - 1;
        this.setState({
          secondGetNewConfig: s,
        });
      } else {
        this.setState({
          getNewConfigFlag: false,
          secondGetNewConfig: 0,
        });
        clearInterval(timeOut);
      }
    }, 1000);
  };

  render() {
    const textAlign = {
      textAlign: "center",
    };

    const marginTop = {
      marginTop: "20px",
    };

    const content = (
      <div className="stubParamsConfig">
        <Row>
          <Col span={6} offset={1}>
            <label htmlFor="stubParamsConfig">{this.internationalization.title8}：</label>
            <span>{this.state.stubId}</span>
          </Col>
          <Col span={15} offset={2}>
            <label htmlFor="stubParamsConfig">{this.internationalization.title9}：</label>
            <span>{this.state.stubGroupName}</span>
          </Col>
        </Row>
        <Row style={marginTop} gutter={24}>
          <Col span={8}>
            <Card style={textAlign}>
              <div>
                <label htmlFor="span">配置最新上报时间：</label>
                <span>
                  {(this.state.cfgData && this.state.cfgData.stubConfigAppearTime) || "--"}
                </span>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={textAlign}>
              <div>
                <label htmlFor="span">配置最新下发修改时间:</label>
                <span>
                  {(this.state.cfgData && this.state.cfgData.platformConfigIssueTime) || "--"}
                </span>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={textAlign}>
              <div>
                <label htmlFor="12">配置最新变更时间:</label>
                <span>
                  {(this.state.cfgData && this.state.cfgData.stubConfigModifyTime) || "--"}
                </span>
              </div>
            </Card>
          </Col>
        </Row>
        <Row style={marginTop}>
          <Col span={4} offset={1}>
            <label htmlFor="stubParamsConfig">
              {this.internationalization.title16}:(SCPP2.1
              {this.state.devType === 0 ? "交流" : "直流"})
            </label>
          </Col>
          <Col span={18} offset={1} style={{ textAlign: "right" }}>
            {this.state.changeValueFlag ? (
              <span>
                <Button
                  type="primary"
                  style={{ marginLeft: "4px" }}
                  onClick={this.handleSaveBtnClick}>
                  保存
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: "4px" }}
                  onClick={() => {
                    this.setState(
                      {
                        resultData: new Map(),
                        changeData: {},
                        changeValueFlag: false,
                      },
                      () => {
                        this.setState({
                          tableColumnsModel: this.tableConfig(),
                        });
                      },
                    );
                  }}>
                  取消
                </Button>
              </span>
            ) : (
              <Button
                type="primary"
                style={{ marginLeft: "4px" }}
                onClick={() => {
                  this.setState(
                    {
                      changeValueFlag: true,
                    },
                    () => {
                      this.setState({
                        tableColumnsModel: this.tableConfig(),
                      });
                    },
                  );
                }}>
                修改配置
              </Button>
            )}
            <Button
              type="primary"
              disabled={this.state.changeValueFlag || this.state.getNewConfigFlag}
              style={{ marginLeft: "4px" }}
              loading={this.state.checkBtnLoading}
              onClick={this.handleConfigCheckClick}>
              获取最新配置
              {this.state.secondGetNewConfig > 0 ? `(${this.state.secondGetNewConfig}s)` : ""}
            </Button>
            <Button
              type="primary"
              disabled={this.state.changeValueFlag}
              style={{ marginLeft: "4px" }}
              onClick={this.handleModifyLogBtnClick}>
              {this.internationalization.title21}
            </Button>
            <Button
              type="primary"
              disabled={this.state.changeValueFlag}
              style={{ marginLeft: "4px" }}
              onClick={this.handlerefreshBtnClick}>
              {this.internationalization.title22}
            </Button>
          </Col>
        </Row>
        <Row style={marginTop}>
          <Col span={22} offset={1}>
            <div className="configTable">
              <Table
                columns={this.state.tableColumnsModel}
                dataSource={(this.state.cfgData && this.state.cfgData.configData) || ""}
                pagination={false}
                bordered
                locale={TableLocale}
                className="sc-table"
                scroll={{ y: 440 }}
              />
            </div>
          </Col>
        </Row>

        <Modal
          title={this.internationalization.title21}
          width="1100px"
          footer={null}
          visible={this.state.configModifyLogVisible}
          onCancel={() => {
            this.modalVisibleAction("configModifyLogVisible", false);
          }}>
          <ModifyLog stubId={this.state.stubId} />
          {/* handle={this.handleModifyLog} */}
        </Modal>

        <StubParamPriceModal
          okFunction={(returnValue) => {
            // 获取record
            const record1 = this.state.cfgData.configData.filter((item) => item.key === "num")[0];
            const record2 = this.state.cfgData.configData.filter((item) => item.key === "time")[0];
            const record3 = this.state.cfgData.configData.filter(
              (item) => item.key === "elePrice",
            )[0];
            const record4 = this.state.cfgData.configData.filter(
              (item) => item.key === "serverPrice",
            )[0];
            // const record5 = this.state.cfgData.configData.filter(item => item.key === "type")[0];
            this.handleStubCfgEditChange2(returnValue.num, record1);
            this.handleStubCfgEditChange2(returnValue.time, record2);
            this.handleStubCfgEditChange2(returnValue.elePrice, record3);
            this.handleStubCfgEditChange2(returnValue.serverPrice, record4);
            //  this.handleStubCfgEditChange2(returnValue.type,record5);
            this.setState({
              priceSetVisible: false,
            });
          }}
          onCancel={() => {
            this.setState({
              priceSetVisible: false,
            });
          }}
          visible={this.state.priceSetVisible}
        />
        <StubParamChargingModal
          okFunction={(returnValue) => {
            // 获取record
            const record1 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointNum",
            )[0];
            const record2 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointStartTime",
            )[0];
            const record3 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointEndTime",
            )[0];
            const record4 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointEle",
            )[0];
            const record5 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointTimeLen",
            )[0];
            this.handleStubCfgEditChange2(returnValue.appointNum, record1);
            this.handleStubCfgEditChange2(returnValue.appointStartTime, record2);
            this.handleStubCfgEditChange2(returnValue.appointEndTime, record3);
            this.handleStubCfgEditChange2(returnValue.appointEle, record4);
            this.handleStubCfgEditChange2(returnValue.appointTimeLen, record5);
            this.setState({
              chargingSetVisible: false,
            });
          }}
          onCancel={() => {
            this.setState({
              chargingSetVisible: false,
            });
          }}
          visible={this.state.chargingSetVisible}
        />
      </div>
    );
    return content;
  }
}

export default injectIntl(StubParamsConfig);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubParamsConfig.js